import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Col, Row } from "react-bootstrap"

import { IDLE, PENDING, SUCCESS, EDIT, VIEW } from "const"
import { ccCompliantItemsRoute } from "client/parts/routes"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadNestedItems,
    GetMaxCcLibraryItems,
    ImportCcLibraryItemsFromFile,

    setCcLibraryHeadingList,
    setCcLibraryItemList,
    setCcLibraryItemNested,
    setCcLibraryItemReloadList,
    setCcLibraryItemParents,
    addModal,
} from "client/store"
import {
    Container,
    PageForm,
    Feedback,
    Button,
    Loader,
} from "client/components"
import NestedList from "./nestedList"
import PopupMenu from "./popupMenu"
import ConfirmDeleteHeading from "./confirmDeleteHeading"
import ConfirmDeleteItem from "./confirmDeleteItem"
import HeadingEdit from "../headingEdit"

let itemNumber = 0

interface ItemListProps {
    setId: number
    editAccess: boolean
}

const ItemList = ({
    setId = null,
    editAccess,
}: ItemListProps) => {
    const baseLibraryRoute = useSelector((state: StoreType) => state.ccLibrarySet.baseRoute)
    const reloadList = useSelector((state: StoreType) => state.ccLibraryItem.reloadList)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const baseRoute = `${baseLibraryRoute}/${VIEW}/${setId}${ccCompliantItemsRoute}`

    // max number of compliant items
    const maxItemNumber = GetMaxCcLibraryItems(packageSettings, userData, project.id)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)

        LoadNestedItems(setId, project.id, userData.accountId)
        .then((res) => {
            itemNumber = res.count

            dispatch(setCcLibraryItemList(res.itemList))
            dispatch(setCcLibraryHeadingList(res.headingList))
            dispatch(setCcLibraryItemNested(res.nested))

            setLoadState(IDLE)
        })
    }, [reloadList])

    const ImportFromFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        const target = e.currentTarget
        const { files } = target
        if (files.length === 0) return

        setLoadState(PENDING)
        ImportCcLibraryItemsFromFile(setId, project.id, userData, files[0], itemNumber, maxItemNumber).then(() => {
            target.value = null
            dispatch(setCcLibraryItemReloadList(false))
            setTimeout(() => {
                dispatch(setCcLibraryItemReloadList(true))
            }, 0)
        })
    }


    let feedbackMaxItems = ""
    if (maxItemNumber === 0) feedbackMaxItems = lang.maxLibraryItemsNone
    else if (maxItemNumber !== null) {
        feedbackMaxItems = lang.maxLibraryItems.replace("{0}", maxItemNumber.toString()).replace("{1}", itemNumber.toString())
    }

    const allowedToAdd = editAccess && (maxItemNumber === null || itemNumber < maxItemNumber)

    return (
        <Container>
            {
                loadState === PENDING
                && <Loader />
            }
            <PageForm>
                {
                    editAccess && (
                        <Row>
                            <Col xs={12}>
                                <Feedback variant={SUCCESS}>{feedbackMaxItems}</Feedback>
                            </Col>
                            <Col xs={12}>
                                <Button row disabled={!allowedToAdd}>
                                    <input
                                        type="file"
                                        accept=".xlsx"
                                        title={lang.selectFile}
                                        onChange={(e) => ImportFromFile(e)}
                                    />
                                    {lang.importFromFile}
                                </Button>
                                <Button
                                    row
                                    onClick={() => dispatch(addModal({
                                        key: "addParagraph",
                                        content: <HeadingEdit headingId={0} parentId={null} />,
                                    }))}
                                >
                                    {lang.addParagraph}
                                </Button>
                                <Button
                                    row
                                    disabled={!allowedToAdd}
                                    onClick={() => {
                                        dispatch(setCcLibraryItemParents(null, null))
                                        dispatch(addModal({ url: `${baseRoute}/${EDIT}/0` }))
                                    }}
                                >
                                    {lang.addCompliantItem}
                                </Button>
                            </Col>
                        </Row>
                    )
                }
                <NestedList editAccess={editAccess} />
                <PopupMenu
                    editAccess={editAccess}
                    addAccess={allowedToAdd}
                    baseRoute={baseRoute}
                />
                <ConfirmDeleteHeading />
                <ConfirmDeleteItem />
            </PageForm>
        </Container>
    )
}
export default ItemList
